import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { Selection } from 'prosemirror-state';
import { inSameTable } from './utils/tables';
export var CellBookmark = /*#__PURE__*/function () {
  function CellBookmark(anchor, head) {
    _classCallCheck(this, CellBookmark);

    this.anchor = anchor;
    this.head = head;
  }

  _createClass(CellBookmark, [{
    key: "map",
    value: function map(mapping) {
      return new CellBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
  }, {
    key: "resolve",
    value: function resolve(doc) {
      var $anchorCell = doc.resolve(this.anchor);
      var $headCell = doc.resolve(this.head);

      if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && inSameTable($anchorCell, $headCell)) {
        var data = {
          type: 'cell',
          anchor: $anchorCell.pos,
          head: $headCell.pos
        };
        return Selection.fromJSON(doc, data);
      }

      return Selection.near($headCell, 1);
    }
  }]);

  return CellBookmark;
}();